import SnippetValidator, {validationCriteriaStructure} from './validators';
import SnippetIsInvalidError from './snippet-is-invalid-error';
import AttributesMapFactory from 'components/organisms/players-csv/attributes-map-factory';
import {getPropValues} from 'helpers/array-helper';

const PlayersSnippetValidatorFactory = {
    getValidator(sportConfig): SnippetValidator {
        try {
            const attributes = AttributesMapFactory.fromSportConfig(sportConfig);
            const requiredAttributes = attributes.filter((attribute) => attribute.isRequiredOnUploading);
            const validationCriteria: validationCriteriaStructure = {
                headerFormat: getPropValues(requiredAttributes, 'headAttributeName'),
            };

            return new SnippetValidator(validationCriteria);
        } catch (e) {
            if (e instanceof TypeError) {
                throw new SnippetIsInvalidError('Validator is undefined.');
            }
            throw e;
        }
    },
};

export default PlayersSnippetValidatorFactory;
